import { Select } from '@profgeosoft-ui/react';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import { useMemo, useState } from 'react';

import { hasValue } from 'src/shared/utils/common';
import { useStore } from 'src/store';

import { ImportItem } from './import-item';
import { ImportProgressStore } from './import-progress-store';
import styles from './import-progress.module.scss';

export const ImportProgress = observer(function ImportProgress() {
  const { router, comparison, notifications, jobsStore, planVersionsService } = useStore();

  const [store] = useState(
    () => new ImportProgressStore(planVersionsService, jobsStore, notifications, router, comparison),
  );

  const draftsMap = useMemo(() => {
    return new Map(planVersionsService.draftsList.map((d) => [d.id, d]));
  }, [planVersionsService.draftsList]);
  const planVersionsMap = useMemo(() => {
    return new Map(planVersionsService.actualPlanVersions.map((v) => [v.id, v]));
  }, [planVersionsService.actualPlanVersions]);

  const currentVersionJob = store.currentVersionJob;

  const selectValue = useMemo(() => {
    if (currentVersionJob) {
      return {
        label: (
          <div style={{ backgroundColor: 'transparent' }}>
            <ImportItem
              job={currentVersionJob}
              parentPlanVersion={null}
              onCancel={() => store.handleCancelImport(currentVersionJob!)}
              onContinue={() => store.onGoToImport(currentVersionJob!)}
            />
          </div>
        ),
        value: currentVersionJob.id,
      };
    }

    return {
      label: (
        <div className={styles.selectStubWrapper}>
          <p>Активные импорты: {store.importJobs.length}</p>
        </div>
      ),
    };
  }, [currentVersionJob, store]);

  if (!store.importJobs.length) {
    return null;
  }

  if (currentVersionJob && store.importJobs.length === 1) {
    return (
      <ImportItem
        job={currentVersionJob}
        parentPlanVersion={null}
        onCancel={() => store.handleCancelImport(currentVersionJob)}
        onContinue={() => store.onGoToImport(currentVersionJob)}
      />
    );
  }

  return (
    <Select
      dropdownMatchSelectWidth={false}
      value={selectValue}
      className={clsx(currentVersionJob ? styles.select : styles.select__withStub)}
      popupClassName={styles.selectPopUp}
      dropdownRender={() => {
        return (
          <div className={styles.dropdown}>
            {store.importJobs.map((job) => {
              if (job === store.currentVersionJob) {
                return null;
              }

              const parentPlanVersion = (() => {
                if (!hasValue(job.result?.planVersionId)) {
                  return null;
                }

                const draft = draftsMap.get(job.result?.planVersionId);

                if (!draft || !hasValue(draft.data.parentVersionId)) {
                  return null;
                }

                return planVersionsMap.get(draft.data.parentVersionId) ?? null;
              })();

              return (
                <ImportItem
                  key={job.id}
                  job={job}
                  parentPlanVersion={parentPlanVersion}
                  onCancel={() => store.handleCancelImport(job)}
                  onContinue={() => store.onGoToImport(job)}
                />
              );
            })}
          </div>
        );
      }}
    />
  );
});
